(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/pages/order-home/message/page.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/pages/order-home/message/page.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _svs$ui$reactForm = svs.ui.reactForm,
  ControlGroup = _svs$ui$reactForm.ControlGroup,
  Select = _svs$ui$reactForm.Select,
  Option = _svs$ui$reactForm.Option,
  Form = _svs$ui$reactForm.Form;
const TextInput = svs.ui.reactFormInputs.TextInput;
const CartBottomSheetContinueSubmit = svs.ticketsOrderHome.orderHome.components.CartBottomSheetContinueSubmit;
const _svs$ticketsOrderHome = svs.ticketsOrderHome.data.config.orderHome.orderHomeMessage,
  headerTitle = _svs$ticketsOrderHome.headerTitle,
  greetings = _svs$ticketsOrderHome.greetings;
const _svs$ticketsOrderHome2 = svs.ticketsOrderHome.utils.constants.orderHomeMessage,
  GREETING_LABEL = _svs$ticketsOrderHome2.GREETING_LABEL,
  FOOTER_TEXT = _svs$ticketsOrderHome2.FOOTER_TEXT,
  MAX_GREETING_LENGTH = _svs$ticketsOrderHome2.MAX_GREETING_LENGTH;
const validators = svs.ticketsOrderHome.utils.validators;
const PREVIEW_COVERLETTER = svs.ticketsOrderHome.routes.ORDER_HOME.PREVIEW_COVERLETTER;
const OrderHomeContext = svs.ticketsOrderHome.context.OrderHomeContext;
const _React = React,
  useState = _React.useState,
  useRef = _React.useRef,
  useContext = _React.useContext,
  useEffect = _React.useEffect;
const PreviewCard = svs.ticketsOrderHome.orderHome.components.PreviewCard;
setGlobal('svs.ticketsOrderHome.pages.Message', _ref => {
  let history = _ref.history;
  const formId = 'order-home-message-form-id';
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    btnDisabled = _useState2[0],
    setBtnDisabled = _useState2[1];
  const _useContext = useContext(OrderHomeContext),
    state = _useContext.state,
    setPersonalGreetingInput = _useContext.setPersonalGreetingInput,
    setGreetingInput = _useContext.setGreetingInput;
  const mountedRef = useRef(null);
  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);
  const handleGreetingMessageChange = e => {
    if (mountedRef.current) {
      const cursorPosition = e.target.selectionStart - e.target.value.length + state.greetingMessage.length;
      btnDisabled && setBtnDisabled(false);
      setGreetingInput(e.target.value);

      if (e.target.value.length > MAX_GREETING_LENGTH) {
        const nativeValueSetter = Object.getOwnPropertyDescriptor(window.HTMLTextAreaElement.prototype, 'value').set;
        nativeValueSetter.call(e.target, state.greetingMessage);
        const event = new Event('input', {
          bubbles: true
        });
        e.target.dispatchEvent(event);
        requestAnimationFrame(() => {
          e.target.setSelectionRange(cursorPosition, cursorPosition);
        });
      }
    }
  };
  const onSubmitHandler = (e, formData) => {
    e.preventDefault();
    const hasInvalidInputs = Object.values(formData).some(value => !value.isValid);
    if (hasInvalidInputs) {
      setBtnDisabled(true);
      return;
    }
    history.push(PREVIEW_COVERLETTER);
  };
  const onValidate = (_, valid) => {
    mountedRef.current && setBtnDisabled(!valid);
  };
  return React.createElement(Form, {
    id: formId,
    onSubmit: onSubmitHandler,
    onValidate: onValidate
  }, React.createElement("div", {
    className: "order-home-message-page w100 u-flex u-flex-align-items-center u-flex-column bg-white padding-h-2"
  }, React.createElement("div", {
    className: "order-home-message-body w100 f-body"
  }, React.createElement("h2", {
    className: "h2 u-text-center padding-top-3"
  }, headerTitle), React.createElement(PreviewCard, null), React.createElement(ControlGroup, {
    v2: true
  }, React.createElement(Select, {
    label: "Rubrik p\xE5 h\xE4lsningen",
    onChange: e => {
      setPersonalGreetingInput(e.target.value);
    },
    v2: true,
    value: state.personalGreeting
  }, greetings.map(_ref2 => {
    let personalGreetingInput = _ref2.personalGreetingInput;
    const key = personalGreetingInput.replace(' ', '-').toLowerCase();
    return React.createElement(Option, {
      className: state.personalGreeting === personalGreetingInput ? 'order-home-selected-option' : '',
      id: key,
      key: key,
      name: personalGreetingInput,
      value: personalGreetingInput
    }, personalGreetingInput);
  }))), React.createElement("div", {
    className: "u-flex u-flex-column w100 margin-bottom-1"
  }, React.createElement(TextInput, {
    isMultiline: true,
    isRequired: false,
    label: GREETING_LABEL,
    max: MAX_GREETING_LENGTH,
    name: "greetingMessage",
    onChange: handleGreetingMessageChange,
    rows: 9,
    showCharCounter: true,
    validateFn: validators,
    value: state.greetingMessage || ''
  })), React.createElement("div", {
    className: "u-text-center"
  }, React.createElement("p", {
    className: "f-medium"
  }, FOOTER_TEXT)), React.createElement(CartBottomSheetContinueSubmit, {
    disabled: btnDisabled,
    formId: formId
  }))));
});

 })(window);